import { HoldingsAndTransferBalancesReconciliationEntry } from 'api/rtk-api'

export interface ReconciliationTableRowData extends HoldingsAndTransferBalancesReconciliationEntry {
  breaking: boolean
  difference: number
  warning: boolean
}

export const mapTableRowData = (
  entries: HoldingsAndTransferBalancesReconciliationEntry[]
): ReconciliationTableRowData[] =>
  (entries ?? []).map(entry => {
    const executionAgentHoldings =
      entry.executionAgentHoldings <= 0 ? 0 : entry.executionAgentHoldings
    const difference = executionAgentHoldings - entry.internalHoldings
    return {
      ...entry,
      difference,
      executionAgentHoldings,
      breaking: entry.executionAgentHoldings < entry.internalHoldings,
      warning: !entry.assetId || !entry.assetName || difference !== 0
    }
  })
